/* AIOO Kevlar landing page: model + colour configurator, add to cart, phone sticky bar, funnel events.
   Markup contract (sections/ap-kevlar.liquid): [data-kv] root, #kv-data JSON (products, addons, models, colors, labels),
   [data-kv-model] / [data-kv-color] radios, [data-kv-atc] main button, [data-kv-pick-model] / [data-kv-pick-color] shortcuts,
   [data-kv-goto="buy"] links, #kv-sticky bar. No dependencies. Add to cart posts to /cart/add.js and then reuses the
   theme's own cart UI (quick add popup or the cart drawer), exactly like the product form does.
   URL: ?model=17pro|18pro|17promax|18promax and ?color=melna|tumsi-zila|bruna-sarkana preselect the options (ad deep links);
   the page keeps them in the address bar with history.replaceState so a shared link opens the same choice. */
(function () {
  'use strict';
  var root = document.querySelector('[data-kv]');
  var dataEl = document.getElementById('kv-data');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var L = D.labels || {};
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  var el = {
    buy: document.getElementById('kv-buy'),
    main: $('[data-kv-main-img]'),
    modelGroup: $('[data-kv-model-group]'),
    modelNote: $('[data-kv-model-note]'),
    modelInputs: $$('[data-kv-model]'),
    colorInputs: $$('[data-kv-color]'),
    colorName: $('[data-kv-color-name]'),
    priceNow: $('[data-kv-price-now]'),
    priceWas: $('[data-kv-price-was]'),
    priceSave: $('[data-kv-price-save]'),
    pricePill: $('[data-kv-price-pill]'),
    addon: $('[data-kv-addon]'),
    addonInput: $('[data-kv-addon-input]'),
    addonText: $('[data-kv-addon-text]'),
    stock: $('[data-kv-stock]'),
    atc: $('[data-kv-atc]'),
    atcLabel: $('[data-kv-atc-label]'),
    status: $('[data-kv-status]'),
    swImgs: $$('[data-kv-sw-img]'),
    cImgs: $$('[data-kv-cimg]'),
    sticky: document.getElementById('kv-sticky'),
    stickyImg: $('[data-kv-sticky-img]', document),
    stickyTitle: $('[data-kv-sticky-title]', document),
    stickySub: $('[data-kv-sticky-sub]', document),
    stickyBtn: $('[data-kv-sticky-btn]', document),
    stickyLabel: $('[data-kv-sticky-label]', document)
  };
  if (!el.atc || !el.main) return;

  var state = { model: '', color: 'melna', sizeHint: '', touched: false };
  var busy = false;
  var doneTimer = 0;
  var swapTimer = 0;

  /* ---- helpers --------------------------------------------------------------- */
  function track(name, data) {
    var payload = Object.assign({ language: D.lang || document.documentElement.lang || '' }, data || {});
    try {
      if (typeof window.AIOO_trackUxEvent === 'function') window.AIOO_trackUxEvent(name, payload);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) { /* non-blocking */ }
  }
  function imgUrl(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function sizeOf() {
    if (state.model && D.models[state.model]) return D.models[state.model].size;
    return state.sizeHint || (D.products.pro ? 'pro' : 'promax');
  }
  function productFor(size) { return D.products[size] || D.products.pro || D.products.promax; }
  function variantFor(prod, color) {
    if (!prod) return null;
    for (var i = 0; i < prod.variants.length; i++) if (prod.variants[i].color === color) return prod.variants[i];
    return prod.variants[0] || null;
  }
  function currentVariant() { return variantFor(productFor(sizeOf()), state.color); }
  function colorKeyFromParam(v) {
    v = String(v || '').toLowerCase().replace(/-/g, '_');
    return D.colors[v] ? v : '';
  }
  function modelFromSlug(s) {
    s = String(s || '').toLowerCase();
    var gen = /18/.test(s) ? '18' : (/17/.test(s) ? '17' : '');
    if (!gen || !/pro/.test(s)) return '';
    return gen + (/max/.test(s) ? 'promax' : 'pro');
  }
  function scrollToBuy() {
    if (!el.buy) return;
    el.buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  function setStatus(msg) { if (el.status) el.status.textContent = msg || ''; }

  /* ---- rendering ------------------------------------------------------------------- */
  function swapGallery(v, prod) {
    if (!v || !v.img) return;
    var url = imgUrl(v.img, 900);
    if (el.main.getAttribute('data-kv-cur') === url) return;
    el.main.setAttribute('data-kv-cur', url);
    var alt = prod.title + ' - ' + (D.colors[state.color] ? D.colors[state.color].name : '');
    var pre = new Image();
    pre.onload = function () {
      window.clearTimeout(swapTimer);
      el.main.classList.add('is-swap');
      swapTimer = window.setTimeout(function () {
        el.main.src = url;
        el.main.srcset = imgUrl(v.img, 480) + ' 480w, ' + imgUrl(v.img, 720) + ' 720w, ' + imgUrl(v.img, 1080) + ' 1080w';
        el.main.alt = alt;
        el.main.classList.remove('is-swap');
      }, reduce ? 0 : 140);
    };
    pre.src = url;
  }

  function render() {
    var size = sizeOf();
    var prod = productFor(size);
    var v = variantFor(prod, state.color);
    if (!prod || !v) return;

    swapGallery(v, prod);

    el.swImgs.forEach(function (img) {
      var sv = variantFor(prod, img.getAttribute('data-kv-sw-img'));
      if (sv && sv.img) { var u = imgUrl(sv.img, 160); if (img.getAttribute('src') !== u) img.src = u; }
    });
    el.cImgs.forEach(function (img) {
      var cv = variantFor(prod, img.getAttribute('data-kv-cimg'));
      if (cv && cv.img) { var u = imgUrl(cv.img, 560); if (img.getAttribute('src') !== u) img.src = u; }
    });

    if (el.colorName && D.colors[state.color]) el.colorName.textContent = D.colors[state.color].name;
    if (el.priceNow) el.priceNow.textContent = v.price_fmt;
    if (el.priceWas) {
      el.priceWas.textContent = v.compare_fmt;
      var wasLine = el.priceWas.closest('.kv-price__wasline');
      if (wasLine) wasLine.hidden = !v.compare_fmt;
    }
    if (el.priceSave) {
      el.priceSave.textContent = (L.save || '').replace('__AMOUNT__', v.save_fmt);
      el.priceSave.hidden = !v.save_fmt;
    }
    if (el.pricePill) {
      el.pricePill.textContent = v.percent ? '-' + v.percent + '%' : '';
      el.pricePill.hidden = !v.percent;
    }

    var m = state.model ? D.models[state.model] : null;
    if (el.modelNote && !el.modelNote.classList.contains('is-error')) el.modelNote.textContent = m ? m.note : '';

    /* add-on (screen protector) only after the model is known, hidden when the shop has none for it */
    var ad = state.model && D.addons ? D.addons[state.model] : null;
    if (el.addon) {
      el.addon.hidden = !ad;
      if (ad && el.addonText) {
        el.addonText.textContent = (L.addon || '').replace('__MODEL__', m.label).replace('__PRICE__', ad.price_fmt);
      }
      if (!ad && el.addonInput) el.addonInput.checked = false;
    }

    /* only a real, low number is shown (never invented) */
    if (el.stock) {
      var low = v.qty !== null && v.qty > 0 && v.qty <= 5;
      el.stock.hidden = !low;
      if (low) el.stock.textContent = (L.stockLow || '').replace('__COUNT__', v.qty);
    }

    /* main button */
    var btnClass = 'kv-atc';
    var label;
    var disabled = false;
    if (!state.model) { label = L.needModel; btnClass += ' is-need'; }
    else if (!v.available) { label = L.soldOut; disabled = true; }
    else { label = L.atc + ' · ' + v.price_fmt; }
    if (!el.atc.classList.contains('is-done') && !busy) {
      el.atc.className = btnClass;
      el.atcLabel.textContent = label;
    }
    el.atc.disabled = disabled;
    el.atc.setAttribute('aria-disabled', disabled ? 'true' : 'false');

    /* sticky bar */
    if (el.sticky) {
      if (el.stickyImg && v.img) { el.stickyImg.src = imgUrl(v.img, 120); el.stickyImg.hidden = false; }
      if (el.stickyTitle) el.stickyTitle.textContent = (L.stickyTitle || 'AIOO Kevlar') + ' · ' + v.price_fmt;
      if (el.stickySub) el.stickySub.textContent = (m ? m.label + ' · ' : '') + (D.colors[state.color] ? D.colors[state.color].name : '');
      if (el.stickyLabel) el.stickyLabel.textContent = state.model && v.available ? L.atc : (v.available ? L.choose : L.soldOut);
      if (el.stickyBtn) el.stickyBtn.disabled = !v.available;
    }
    if (state.touched) syncUrl();
  }

  function syncUrl() {
    try {
      var u = new URL(window.location.href);
      if (state.model) u.searchParams.set('model', state.model); else u.searchParams.delete('model');
      var c = D.colors[state.color];
      if (c) u.searchParams.set('color', c.slug);
      window.history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) { /* ignore */ }
  }

  /* ---- selection ----------------------------------------------------------------------- */
  function setModel(key, opts) {
    opts = opts || {};
    if (!D.models[key]) return;
    if (!opts.silent) state.touched = true;
    state.model = key;
    state.sizeHint = D.models[key].size;
    el.modelInputs.forEach(function (inp) { inp.checked = inp.value === key; });
    if (el.modelNote) el.modelNote.classList.remove('is-error');
    if (el.modelGroup) el.modelGroup.classList.remove('is-need');
    render();
    if (!opts.silent) track('kevlar_lp_select_model', { model: key });
  }
  function setColor(key, opts) {
    opts = opts || {};
    if (!D.colors[key]) return;
    if (!opts.silent) state.touched = true;
    state.color = key;
    el.colorInputs.forEach(function (inp) { inp.checked = inp.value === key; });
    render();
    if (!opts.silent) track('kevlar_lp_select_color', { color: key });
  }
  function needModel(source) {
    if (el.modelGroup) {
      el.modelGroup.classList.remove('is-need');
      void el.modelGroup.offsetWidth;
      el.modelGroup.classList.add('is-need');
    }
    if (el.modelNote) { el.modelNote.textContent = L.modelRequired || ''; el.modelNote.classList.add('is-error'); }
    track('kevlar_lp_need_model', { source: source || 'buy' });
    scrollToBuy();
    window.setTimeout(function () { if (el.modelInputs[0]) el.modelInputs[0].focus({ preventScroll: true }); }, reduce ? 0 : 450);
  }

  /* ---- add to cart ------------------------------------------------------------------------------ */
  function cartAddUrl() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (r || '/') + 'cart/add.js';
  }
  function refreshCartCount() {
    try {
      if (typeof window.freeShippMsg === 'function') { window.freeShippMsg(); return; }
      if (!window.routes || !window.routes.url) return;
      fetch(window.routes.url + '/?section_id=cart-template').then(function (r) { return r.text(); }).then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('#cartItems');
        if (!src) return;
        document.querySelectorAll('.site-header__cart-count[data-cart-count]').forEach(function (n) { n.innerHTML = src.innerHTML; });
      });
    } catch (e) { /* non-blocking */ }
  }
  function setBusy(on) {
    busy = on;
    el.atc.classList.toggle('is-busy', on);
    if (on) el.atcLabel.textContent = L.adding;
  }
  function add(source) {
    if (busy) return;
    var v = currentVariant();
    if (!state.model) { needModel(source); return; }
    if (!v || !v.available) return;
    var ad = D.addons && D.addons[state.model] && el.addonInput && el.addonInput.checked ? D.addons[state.model] : null;
    var items = [{ id: v.id, quantity: 1 }];
    if (ad) items.push({ id: ad.id, quantity: 1 });
    var cart = document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    setStatus('');
    setBusy(true);
    track('kevlar_lp_atc_click', { model: state.model, color: state.color, addon: ad ? 1 : 0, source: source || 'buy', value: v.price / 100, currency: 'EUR' });
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw res.j;
        setBusy(false);
        el.atc.className = 'kv-atc is-done';
        el.atcLabel.textContent = L.added;
        window.clearTimeout(doneTimer);
        doneTimer = window.setTimeout(function () { el.atc.classList.remove('is-done'); render(); }, 2400);
        track('kevlar_lp_atc_success', { model: state.model, color: state.color, addon: ad ? 1 : 0, value: v.price / 100, currency: 'EUR' });
        if (cart && typeof cart.renderContents === 'function') {
          var single = !res.j.items;
          if (!(single && typeof window.AIOO_openQuickAddPopup === 'function' && window.AIOO_openQuickAddPopup(res.j))) {
            cart.renderContents(res.j);
          }
        } else {
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
        }
        refreshCartCount();
      })
      .catch(function (err) {
        setBusy(false);
        render();
        setStatus((err && err.description) || L.error);
        track('kevlar_lp_atc_error', { model: state.model, color: state.color });
      });
  }

  /* ---- events ------------------------------------------------------------------------------------ */
  el.modelInputs.forEach(function (inp) { inp.addEventListener('change', function () { if (inp.checked) setModel(inp.value); }); });
  el.colorInputs.forEach(function (inp) { inp.addEventListener('change', function () { if (inp.checked) setColor(inp.value); }); });
  el.atc.addEventListener('click', function () { add('buy'); });

  root.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var goto = t.closest('[data-kv-goto]');
    if (goto) {
      e.preventDefault();
      track('kevlar_lp_cta', { placement: goto.closest('[data-kv-final]') ? 'final' : 'hero' });
      scrollToBuy();
      window.setTimeout(function () {
        var f = state.model ? el.atc : el.modelInputs[0];
        if (f) f.focus({ preventScroll: true });
      }, reduce ? 0 : 500);
      return;
    }
    var pc = t.closest('[data-kv-pick-color]');
    if (pc) { setColor(pc.getAttribute('data-kv-pick-color'), { source: 'card' }); scrollToBuy(); return; }
    var pm = t.closest('[data-kv-pick-model]');
    if (pm) { setModel(pm.getAttribute('data-kv-pick-model')); scrollToBuy(); }
  });

  if (el.stickyBtn) {
    el.stickyBtn.addEventListener('click', function () {
      var v = currentVariant();
      if (state.model && v && v.available) add('sticky'); else needModel('sticky');
    });
  }

  /* ---- sticky bar visibility (phones): hero CTA gone, main button off screen, closing block not reached ------ */
  (function () {
    if (!el.sticky || !('IntersectionObserver' in window)) return;
    var heroCta = $('[data-kv-hero-cta]');
    var finalEl = $('[data-kv-final]');
    var heroGone = false, atcInView = false, finalReached = false;
    var htmlEl = document.documentElement;
    function apply() {
      var on = heroGone && !atcInView && !finalReached;
      el.sticky.classList.toggle('is-visible', on);
      el.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      htmlEl.classList.toggle('kv-sticky-on', on);
    }
    if (heroCta) new IntersectionObserver(function (en) { var r = en[0]; heroGone = !r.isIntersecting && r.boundingClientRect.top < 0; apply(); }).observe(heroCta);
    new IntersectionObserver(function (en) { atcInView = en[0].isIntersecting; apply(); }).observe(el.atc);
    if (finalEl) new IntersectionObserver(function (en) { var r = en[0]; finalReached = r.isIntersecting || r.boundingClientRect.top < 0; apply(); }).observe(finalEl);
  })();

  /* ---- funnel events: which sections get read, which questions get opened ------------------------------------ */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var names = ['kv-ben', 'kv-detail', 'kv-colors', 'kv-fit', 'kv-svc', 'kv-faq', 'kv-final'];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        track('kevlar_lp_section', { section: en.target.getAttribute('data-kv-sec') });
      });
    }, { threshold: 0.35 });
    names.forEach(function (n) {
      var s = $('.' + n);
      if (s) { s.setAttribute('data-kv-sec', n.replace('kv-', '')); io.observe(s); }
    });
    $$('[data-kv-faq]').forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) track('kevlar_lp_faq_open', { question: d.getAttribute('data-kv-faq') }); });
    });
  })();

  /* ---- initial state: URL params first (ad deep links), then the shopper's remembered phone ------------------------- */
  (function () {
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (e) { params = new URLSearchParams(''); }
    var c = colorKeyFromParam(params.get('color'));
    if (c) state.color = c;
    var vid = params.get('variant');
    if (vid) {
      Object.keys(D.products).forEach(function (size) {
        D.products[size].variants.forEach(function (vv) {
          if (String(vv.id) === String(vid)) { state.sizeHint = size; if (!c) state.color = vv.color; }
        });
      });
    }
    var mp = String(params.get('model') || '').toLowerCase();
    var model = D.models[mp] ? mp : '';
    if (!model) {
      try { model = modelFromSlug(window.localStorage.getItem('AIOO_selectedDevice')); } catch (e) { model = ''; }
      if (model && !D.models[model]) model = '';
    }
    el.colorInputs.forEach(function (inp) { inp.checked = inp.value === state.color; });
    if (model) setModel(model, { silent: true });
    else render();
    track('kevlar_lp_view', { model: state.model, color: state.color, source: params.get('utm_source') || '' });
  })();
})();
